import {fromJS} from 'immutable';
import MAP_STYLE from './default-map-style.json';


// For more information on data-driven styles, see https://www.mapbox.com/help/gl-dds-ref/
export const sessionsLayer = fromJS({
  "id": "sessions",
  "type": "circle",
  "source": "sessions",
  "filter": [
      "all",
      [
          "==",
          "$type",
          "Point"
      ],

  ],
  "paint": {
      "circle-color": ["get", "color"],
      // "circle-radius": ["get", "linesCount"],

      "circle-radius": [
          "step",
          ["get", "linesCount"],
          2,
          10,3,
          20,5,
          30,7
      ]


      // "circle-radius": {
      //           "base": 2,
      //           "stops": [
      //               [5,3],
      //               [7,4],
      //               [9,20],
      //               [9.9,50],
      //           ]
      //       }
  },
  "minzoom" : 7,
  "interactive" : true
});

export const linesLayer = fromJS({

"id": "lines",
"type": "line",
"source": "drawings",
"paint": {
    // "line-width" : 3,
    "line-width": [
        "step",
        ["get", "size"],
        2,
        10,3,
        30,3,
        40,5
    ],
    "line-color" : ["get", "color"],
    // "line-blur" : 10,
},
"minzoom" : 10.99,
"interactive" : true
});

export const clustersLayer = fromJS({
        id: "clusters",
        type: "circle",
        source: "clustered-sessions",
        filter: ["has", "point_count"],
        paint: {
            // Use step expressions (https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
            // with three steps to implement three types of circles:
            //   * Blue, 20px circles when point count is less than 100
            //   * Yellow, 30px circles when point count is between 100 and 750
            //   * Pink, 40px circles when point count is greater than or equal to 750
            "circle-color": [
                "step",
                ["get", "point_count"],
                "#51bbd6",
                100,"#f1f075",
                750,"#f28cb1"
            ],
            "circle-radius": [
                "step",
                ["get", "point_count"],
                15,
                10,20,
                50,50,
                100,30,
                750,40
            ]
        },
        "interactive" : true
    });

    export const clustersCountLayer = fromJS({
        id: "cluster-count",
        type: "symbol",
        source: "clustered-sessions",
        filter: ["has", "point_count"],
        layout: {
            "text-field": "{point_count_abbreviated}",
            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
            "text-size": 12
        }
    });

    export const unclusteredPointLayer = fromJS({
        id: "unclustered-point",
        type: "circle",
        source: "clustered-sessions",
        filter: ["!", ["has", "point_count"]],
        paint: {
            "circle-color": "#11b4da",
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff"
        }
    });


//

export const defaultMapStyle = fromJS(MAP_STYLE);



//
// {
//
// "id": "lines",
// "type": "line",
// "source": "drawings",
// "paint": {
//     "line-width" : 4,
//     "line-color" : ["get", "color"]
// },
// "minzoom" : 10.99,
// "interactive" : true
// }



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/map-style.js